import angular from 'angular';
import UsersReferral from './usersReferral';

export default angular
  .module('components.usersReferral', [])
  .component('usersReferral', UsersReferral).name;
